import { createFileRoute } from '@tanstack/react-router';
import { generateValidateSearch } from '@/lib/filters/validate-search';
import { documentsFilterConfig } from '@/pages/Documents/DocumentsPage.config';

const validateFilters = generateValidateSearch(documentsFilterConfig);

// Explicit literal return type — `generateValidateSearch`'s own signature returns the loose
// `Record<string, unknown>`, which widens this route's inferred search schema and breaks every
// existing `<Link to="/documents" search={{ page: undefined, ... }}>` call site elsewhere (they
// type-check against this route's literal shape, carried over unchanged from before this field
// migration).
interface DocumentsSearch {
  status?: string
  entity?: string
  createdBy?: string
  page?: number
  sort?: string
  order?: 'asc' | 'desc'
  tab?: 'uploaded'
}

export const Route = createFileRoute('/documents/')({
  validateSearch: (search: Record<string, unknown>): DocumentsSearch => ({
    ...(validateFilters(search) as Omit<DocumentsSearch, 'tab'>),
    tab: search.tab === 'uploaded' ? 'uploaded' : undefined,
  }),
});
